import { formatShiftInstant } from '../../core/shifts/shiftTimeZone';
import React from 'react';
import PlannerShiftCard from './PlannerShiftCard';

function millis(value) {
  return value?.toMillis ? value.toMillis() : value?.toDate ? value.toDate().getTime() : new Date(value).getTime();
}

export function historicalShifts(shifts, now) {
  return shifts.filter(shift => {
    const end = millis(shift.endTime);
    return (shift.endTime != null && Number.isFinite(end) && end <= now) ||
      ['completed', 'cancelled', 'canceled', 'no_show', 'closed_unfilled'].includes(String(shift.status).toLowerCase());
  }).sort((a, b) => millis(b.startTime) - millis(a.startTime));
}

export default function PlannerHistory({ shifts, now, selectedShiftId, selectedShiftIds, toggleShiftSelection, onSelect, workersByUid }) {
  const rows = historicalShifts(shifts, now);
  return <section aria-label="Shift history">
    <h2>Shift history</h2>
    <p>All past and closed shifts for this facility · {rows.length} shifts</p>
    {!rows.length && <p>No historical shifts for this facility.</p>}
    <div style={{display:'grid',gap:12}}>{rows.map(shift => <div key={shift.id}>
      <h3>{formatShiftInstant(millis(shift.startTime),shift.timeZone || shift.timezone,{weekday:'long',year:'numeric',month:'short',day:'numeric'})}</h3>
      <PlannerShiftCard shift={shift} now={now} selectedShiftId={selectedShiftId} selectedShiftIds={selectedShiftIds} toggleShiftSelection={toggleShiftSelection} setSelectedShiftId={onSelect} workersByUid={workersByUid} />
    </div>)}</div>
  </section>;
}
